import { useEffect } from 'react';
var stylesMap = {};
export var useStylesWithoutDuplicates = function (identifier, styles) {
    stylesMap[identifier] = stylesMap[identifier] || 0;
    useEffect(function () {
        if (stylesMap[identifier] === 0) {
            styles.use();
        }
        stylesMap[identifier] = stylesMap[identifier] + 1;
        return function () {
            stylesMap[identifier] = stylesMap[identifier] - 1;
            if (stylesMap[identifier] === 0) {
                styles.unuse();
            }
        };
    }, []);
};
